// Common options for page sizes used in pagination.
const PageSizes = [12, 24, 48, 96] as const;

export default PageSizes;
